import * as ActionTypes from "services/state/action-types"
import _get from "lodash/get"
import _map from "lodash/map"
import { TYPE_ERROR } from "services/state/fixedVoice/constants"
import _filter from "lodash/filter"
import _find from "lodash/find"
import _ from "lodash"

const PORTABILITY_INFORMATION_STATE = {
  traffic: null,
  errors: false,
  response: null
}

export function portabilityInformation(
  state = PORTABILITY_INFORMATION_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.GET_PORTABILITY_INFORMATION:
      return { ...state, loading: true, response: action.payload.data }

    case ActionTypes.GET_PORTABILITY_INFORMATION_SUCCESS:
      return {
        ...state,
        errors: false,
        response: action.payload.data,
        loading: false,
        modalOpen: true
      }

    case ActionTypes.GET_PORTABILITY_INFORMATION_FAIL:
      return { ...state, errors: true, loading: false, response: null }

    default:
      return state
  }
}

const NEW_ORDER_STATE = {
  loading: false,
  loadingRequest: false,
  error: null,
  messageError: null,
  duplicateNumber: null,
  order: null,
  response: null,
  localityResponse: {},
  circuit: null,
  documentNumber: null
}

export function newOrder(state = NEW_ORDER_STATE, action) {
  let resultData,
    localitiesFound,
    localitiesName,
    result,
    response,
    responseSale,
    error

  switch (action.type) {
    case ActionTypes.GET_VALID_LOCALITIES:
      return { ...state, loading: true }

    case ActionTypes.GET_VALID_LOCALITIES_SUCCESS:
      resultData = _get(action, "payload.data.response", [])
      localitiesFound = _get(resultData.message, "localities")
      localitiesName = _map(localitiesFound, (locality) => {
        return locality.locality
      })

      result = localitiesFound ? { localitiesName } : resultData.message

      return {
        ...state,
        loading: false,
        localityResponse: {
          ...state.localityResponse,
          ...result
        },
        localities: localitiesFound
      }

    case ActionTypes.GET_VALID_LOCALITIES_FAIL:
      return {
        ...state,
        loading: false,
        error: TYPE_ERROR.LOCALITIES,
        localityResponse: { ufs: state.localityResponse.ufs }
      }

    case ActionTypes.SAVE_DASHBOARD_DOCUMENT:
      return { ...state, documentNumber: action.payload }

    case ActionTypes.GET_VALID_CIRCUITS:
      return {
        ...state,
        loading: false,
        circuit: action.payload
      }

    case ActionTypes.SAVE_ORDER:
      return {
        ...state,
        order: action.payload
      }

    case ActionTypes.SAVE_NEW_SALE_PORTABILITY:
      return {
        ...state,
        loadingSale: true,
        error: null,
        duplicateNumber: null
      }

    case ActionTypes.SAVE_NEW_SALE_PORTABILITY_SUCCESS:
      responseSale = _get(action.payload.data, "response")

      return {
        ...state,
        loadingSale: false,
        error: null,
        duplicateNumber: null,
        response: responseSale
      }

    case ActionTypes.SAVE_NEW_SALE_PORTABILITY_FAIL:
      error = _get(action.error.response.data, "message")

      if (state.order.typeOf === "Portabilidade") {
        const numberValue = _get(
          action.meta.previousAction.payload.request.data,
          "value"
        )
        const numbers = numberValue.split(",")

        let messageArray

        if (error) {
          messageArray = error.split(" ")

          const wrongNumber = _filter(numbers, (num) => {
            return _find(messageArray, (text) => text.startsWith(num))
          })

          return {
            ...state,
            loadingSale: false,
            error: TYPE_ERROR.INVALID_NUMBER,
            duplicateNumber: wrongNumber
          }
        }
      }

      return {
        ...state,
        loadingSale: false,
        error: TYPE_ERROR.SALE_PORTABILITY,
        messageError: error
      }

    case ActionTypes.GET_SPECIALIST_REQUESTS:
    case ActionTypes.SPECIALIST_ANALYSIS:
      return {
        ...state,
        loadingRequest: true
      }

    case ActionTypes.GET_SPECIALIST_REQUESTS_SUCCESS:
    case ActionTypes.SPECIALIST_ANALYSIS_SUCCESS:
      response = _get(action.payload.data, "response")

      return { ...state, loadingRequest: false, error: null, response }

    case ActionTypes.GET_SPECIALIST_REQUESTS_FAIL:
    case ActionTypes.SPECIALIST_ANALYSIS_FAIL:
      return {
        ...state,
        loadingRequest: false
      }

    default:
      return { ...state }
  }
}

const DASH_FIXED_VOICE_STATE = {
  loading: null,
  loadingNumbers: null,
  status: null,
  activeNumbers: null,
  inactiveNumbers: null,
  inProgressNumbers: null,
  qntNumbers: null,
  isLimitAchieved: false,
  numbers: null,
  customers: null,
  customerDetails: null,
  error: null,
  errorStatus: null
}

export function customersFixedVoice(state = DASH_FIXED_VOICE_STATE, action) {
  let status, active, inactive, progress, qnt, isLimitAchieved, code, message

  switch (action.type) {
    case ActionTypes.GET_DASHBOARD_COUNT_STATUS_DETAIL:
    case ActionTypes.GET_DASHBOARD_COUNT_STATUS:
      return { ...state, errorStatus: null, loading: true }

    case ActionTypes.GET_DASHBOARD_COUNT_STATUS_DETAIL_SUCCESS:
    case ActionTypes.GET_DASHBOARD_COUNT_STATUS_SUCCESS:
      status = _get(action.payload.data, "response.message")
      active = _get(status, "ASSET_ATIVO", 0)
      inactive = _get(status, "ASSET_INATIVO", 0)
      progress = _get(status, "ASSET_AGUARDANDO_ATIVACAO", 0)
      qnt = _get(status, "V_QNT_ASSET_PARTNER", 0)
      isLimitAchieved =
        _.toNumber(qnt) <= _.toNumber(active) + _.toNumber(progress)

      return {
        ...state,
        status,
        activeNumbers: active,
        inactiveNumbers: inactive,
        inProgressNumbers: progress,
        qntNumbers: qnt,
        isLimitAchieved,
        loading: false
      }

    case ActionTypes.GET_DASHBOARD_COUNT_STATUS_DETAIL_FAIL:
    case ActionTypes.GET_DASHBOARD_COUNT_STATUS_FAIL:
      code = _get(action.error.response, "data.response.code")
      message = _get(action.error.response, "data.response.message")

      return {
        ...state,
        loading: false,
        errorStatus: `${message} | code ${code}`
      }

    case ActionTypes.GET_DASHBOARD_NUMBERS_DETAIL:
    case ActionTypes.GET_DASHBOARD_NUMBERS_OR_CLIENTS:
      return { ...state, loadingNumbers: true }

    case ActionTypes.GET_DASHBOARD_NUMBERS_DETAIL_SUCCESS:
      return {
        ...state,
        numbers: _get(action.payload.data, "response.message"),
        error: null,
        loadingNumbers: false
      }

    case ActionTypes.GET_DASHBOARD_NUMBERS_OR_CLIENTS_SUCCESS:
      return {
        ...state,
        customers: _get(action.payload.data, "response.message"),
        error: null,
        loadingNumbers: false
      }

    case ActionTypes.GET_DASHBOARD_NUMBERS_DETAIL_FAIL:
    case ActionTypes.GET_DASHBOARD_NUMBERS_OR_CLIENTS_FAIL:
      code = _get(action.error.response, "data.response.code")
      message = _get(action.error.response, "data.response.message")

      return {
        ...state,
        loadingNumbers: false,
        numbers: null,
        customers: null,
        error: `${message} | code ${code}`
      }

    case ActionTypes.GET_CUSTOMER_DETAILS:
      return {
        ...state,
        customerDetails: action.payload
      }

    default:
      return { ...state }
  }
}

const DASH_ACTIONS_FIXED_VOICE_STATE = {
  loadingActions: false,
  datesAvailable: null,
  error: null,
  documentContent: null
}

export function actionsDashFixedVoice(
  state = DASH_ACTIONS_FIXED_VOICE_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.GET_RESCHEDULE_DATES:
      return {
        ...state,
        loadingActions: true,
        error: null
      }

    case ActionTypes.GET_RESCHEDULE_DATES_SUCCESS:
      return {
        ...state,
        datesAvailable: _get(action.payload, "data"),
        loadingActions: false
      }

    case ActionTypes.GET_RESCHEDULE_DATES_FAIL:
      return {
        ...state,
        loadingActions: false,
        error: "Erro ao efetuar operação. Tente mais tarde!"
      }

    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/services/state/fixedVoice/reducer.js